import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { catchError, throwError } from "rxjs";
import { IUsers } from "../model/user";

@Injectable({
  providedIn: "root",
})
export class User {
  private http = inject(HttpClient);
  constructor() {}

  getUserList() {
    return this.http
      .get<IUsers>(`${environment.apiUrl}/auth/users`)
      .pipe(catchError(this.errorHandle));
  }

  getUserListPaginated(rowNum:any,size:any,searchTerm:any,activeOnly:boolean|null,userType:any,sortBy:string,sortOrder:string) {
    const activeParam = (activeOnly !== null && activeOnly !== undefined) ? `&activeOnly=${activeOnly}` : '';
    return this.http
      .get<any>(`${environment.apiUrl}/auth/users/test?rowNum=${rowNum}&size=${size}&searchTerm=${searchTerm}${activeParam}&userType=${userType}&sortBy=${sortBy}&sortOrder=${sortOrder}`)
      .pipe(catchError(this.errorHandle));
  }

  updateUserDetails(user:any){
    return this.http.patch<IUsers>(`${environment.apiUrl}/auth/user`,user)
    .pipe(catchError(this.errorHandle))
  }

   downloadCSV(){
    return this.http.get(`${environment.apiUrl}/auth/download-users`,{responseType:'blob'})
    .pipe(catchError(this.errorHandle));
  }


  getMediaFiles(entityName:any,entityId:any){
    return this.http.get(`${environment.apiUrl}/media/${entityName}/${entityId}`)
  }
  

  getMediaById(id:any){
    return this.http.get<any>(`${environment.apiUrl}/media/${id}`,{responseType:'blob' as  'json'})
    .pipe(catchError(this.errorHandle));
  }

  deleteMediaById(id:any){
    return this.http.delete<any>(`${environment.apiUrl}/media/${id}`)
    .pipe(catchError(this.errorHandle));
  }

  getOrg(){
    return this.http.get<any>(`${environment.apiUrl}/auth/org`)
    .pipe(catchError(this.errorHandle));
  }

  updateOrg(formData:any){
    return this.http.patch<any>(`${environment.apiUrl}/auth/org`,formData)
    .pipe(catchError(this.errorHandle));
  }

  postCRMDetails(form:any){
     return this.http.post(`${environment.apiUrl}/auth/crm_create`,form)
    .pipe(catchError(this.errorHandle));
  }

  

  errorHandle(error: any) {
    let errorMessage = "";
    if (error.error.error instanceof ErrorEvent) {
      errorMessage = error.error.error;
    } else {
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
